import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { revertAll } from './userReducer';

export type Employee = {
	employeeId: string,
	designation: string,
	fullName: string,
	employeeStatus: string,
	employeeType: string,
	picture: string,
	email: string,
	phoneNumber: string,
	userName: string,
	createdAt: number,
	firstName: string,
	lastName: string,
	emergencyContacts?:any,
	bloodGroup?:string,
	personalEmail?:string,
	dateOfBirth?:any,
	expectedHours: number
};

const initialAllEmployeeState: Employee[] = [];

const employeesReducer = createSlice({
	name: 'employees',
	initialState: initialAllEmployeeState,
	reducers: {
		setAllEmployees: (state, action: PayloadAction<Employee[]>) => {
			return action.payload;
	},
		updateEmployee: (state, action) => {

			const indexOfEmployeeToChange = state.findIndex(employee => employee.userName === action.payload.userName);
			const changedEmploee = action.payload;

			state[indexOfEmployeeToChange] = changedEmploee;
			return state;
		},
	},
	extraReducers(builder) {
		builder
			.addCase(revertAll, () => initialAllEmployeeState);
	}
});

export const { setAllEmployees, updateEmployee } = employeesReducer.actions;

export default employeesReducer;
